import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import Layers from "slotworks/graphics/layers/layers";
import Components from "slotworks/components/components";

export default function HidePromoFSonFreespins() {
    if(campaignsModel.isFreespinsActive()) {
        Layers.PromoBetBar.hide();
        Layers.BetBar.show();
        Components.promoBetBar.disablePromoUI(); 
        Layers.SmartButton.show();
    }
}


// WEBPACK FOOTER //
// ./~/slotworks/commands/promo-free-spins/hide-pfs-on-freespins.ts